import { FeatureFlag } from 'model';
import { useUserHasRole } from './useUserHasRole.js';

/**
 * Typesafe hook for featureflag detection
 * @param { FeatureFlag } featureflag FeatureFlag to test for
 * @returns { boolean } true if the user has the FeatureFlag
 */
export function useUserHasFeatureFlag(featureflag: FeatureFlag): boolean {
	return useUserHasRole(featureflag);
}
